import { createSlice } from '@reduxjs/toolkit';

import { logoutWithDelay } from 'store/oauth/service';

import { getChatAuth } from './service';

export const initialState: IChatState = {
  auth: undefined,
  authLoadingStatus: false
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChatAuth.fulfilled, (state, action) => {
        state.auth = action.payload;
        state.authLoadingStatus = false;
      })
      .addCase(getChatAuth.pending, (state) => {
        state.authLoadingStatus = true;
      })
      .addCase(getChatAuth.rejected, (state) => {
        state.authLoadingStatus = false;
      })
      .addCase(logoutWithDelay.fulfilled, () => initialState);
  }
});

const selectChatAuth = (state: IAppState) => state.chat.auth;
const selectChatAuthLoading = (state: IAppState) => state.chat.authLoadingStatus;

export const chatReducer = slice.reducer;
export { selectChatAuth, selectChatAuthLoading };
